import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "dtm-map-zone-legend",
    templateUrl: "./zone-legend.component.html",
    styleUrls: ["./zone-legend.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZoneLegendComponent {}
